import React from 'react'

interface IconButtonProps {
  onClick?: () => void
  children: React.ReactNode
  className?: string
}

export const IconButton: React.FC<IconButtonProps> = ({
  onClick,
  children,
  className = ''
}) => {
  return (
    <button 
      className={`p-1 transition-transform hover:scale-110 active:scale-95 ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  )
} 